export default {"src":"/_next/static/media/arrow-left-outline.5e6a7871.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};